import main from './play-circle.svg';
import active from './play-circle-filled.svg';
import disabled from './play-circle-gestalt.svg';

export default { main, active, disabled };
